// Creates the "DELETE" sql statement
export function destroy(tableName: any) {
  return `DELETE FROM ${tableName} WHERE id = ?;`
}

// Creates the "DELETE ALL" sql statement
export function destroyAll(tableName: any) {
  return `DELETE FROM ${tableName};`
}

export default { destroy, destroyAll }
